const _ = require("lodash");
const StringUtil = require("./StringUtil");
const {
	MINIMUM_PASSWORD_LENGTH,
	MINIMUM_EMAIL_PASSWORD_LENGTH,
} = require("./Constants");

// displayName is optional
const doBaseChecks = function(password, repeatPassword, displayName) {
	// Making sure the passwords match and are at least a minimum length
	if (password.length < MINIMUM_PASSWORD_LENGTH) {
		return {valid: false, error: "E_PASSWORD_TOO_SHORT"};
	}

	if (password !== repeatPassword) {
		return {valid: false, error: "E_PASSWORD_REPEAT_MISMATCH"};
	}

	const lowercasePassword = password.toLowerCase();
	if (displayName) {
		// Making sure parts of the display name aren't in the password.
		const displayNamePieces = displayName.split(" ").filter(p => p.length > 3);
		const lowercaseDisplayName = displayNamePieces.map(p => p.toLowerCase());
		for (let i = 0; i < displayNamePieces.length; i++) {
			if (_.includes(lowercasePassword, lowercaseDisplayName[i])) {
				return {
					valid: false,
					error: "E_DISPLAY_NAME_IN_PASSWORD",
					info: displayNamePieces,
				};
			}
		}
	}

	return {valid: true};
};

// Confidence checks that make sure students don't have too insecure of passwords.
// If you aren't sure you have a student with a username, use checkPassword.
const checkStudentPassword = function(password, repeatPassword, userModel) {
	const lowercasePassword = password.toLowerCase();
	const username = userModel.username;
	const schoolLogin = userModel.schoolLogin;

	if (password.length < MINIMUM_PASSWORD_LENGTH) {
		return {valid: false, error: "E_PASSWORD_TOO_SHORT"};
	}
	if (username) {
		// Making sure the first two parts of the username aren't in the password:
		// i.e. adjective and animal pieces of username cannot be used, but number can be.
		const usernamePieces = _.values(StringUtil.getUsernamePieces(username))
			.filter(p => p.length > 3 && _.isNaN(parseInt(p)))
			.map(p => p.toLowerCase());
		for (let p = 0; p < usernamePieces.length; p++) {
			if (_.includes(lowercasePassword, usernamePieces[p])) {
				return {
					valid: false,
					error: "E_USERNAME_IN_PASSWORD",
					info: usernamePieces.map(_.capitalize),
				};
			}
		}
	}
	if (schoolLogin && lowercasePassword === schoolLogin.toLowerCase()) {
		return {valid: false, error: "E_PASSWORD_IS_USERNAME"};
	}
	if (!schoolLogin && !username) {
		// Wrong function was called
		return {valid: false, error: "E_NO_USERNAME"};
	}

	return doBaseChecks(password, repeatPassword, userModel.displayName);
};

// Confidence checks that passwords being set together with an email for a newly
// registered non-student are okay.
// Currently only used in frontend checks.
const checkEmailPassword = function(password, repeatPassword) {
	if (password.length < MINIMUM_EMAIL_PASSWORD_LENGTH) {
		return {valid: false, error: "E_SHORT_PASSWORD"};
	}
	return doBaseChecks(password, repeatPassword);
};

// Generic function that decides which checking function to use based on what
// the user model has available.
// Currently used in backend checks.
const checkPassword = function(password, repeatPassword, userModel) {
	if (userModel && (userModel.username || userModel.schoolLogin)) {
		return checkStudentPassword(password, repeatPassword, userModel);
	} else if (userModel && userModel.email) {
		return checkEmailPassword(password, repeatPassword);
	} else {
		// Academy students can log in with Platform, and are likely to not have a username or schoolLogin.
		const displayName = _.get(userModel, "displayName", "");
		return doBaseChecks(password, repeatPassword, displayName);
	}
};

module.exports = {
	checkStudentPassword,
	checkEmailPassword,
	checkPassword,
};
